export default __webpack_public_path__ + "static/media/Projects.1b2e1af1.svg";